import Event from 'ol/events/Event';

export class GazetteerEvent extends Event {

  constructor (type, feature) {
    super(type);
    this._feature = feature;
  }

  get feature () {
    return this._feature;
  }

}
